module.exports = __webpack_public_path__ + "home_reserve_v2.e7442de451a0425f768b.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/ranjith/eclipse-workspace/monarch-web-contentful/src/assets/img/home_reserve_v2.jpg
// module id = ../../../../../src/assets/img/home_reserve_v2.jpg
// module chunks = styles